import React, { useState } from 'react';

import FormTitle from 'components/shared/Typography/FormTitle';

import s from '../AddFlights/index.module.css';
import { Actions, Footer } from '../AddFlights/shared';
import { ManuallyFlight } from './ManuallyFlight';
import { ManuallyTransfer } from './ManuallyTransfer';
import { MANUALLY_FLIGHT, MANUALLY_TRANSFER, types } from './utils';

export function AddManually(props) {
  const { formType, currentItem } = props;
  const [activeType, setActiveType] = useState(types[0]);

  const isFlightForm = activeType === MANUALLY_FLIGHT;
  const isTransferForm = activeType === MANUALLY_TRANSFER;
  const handleSetType = (enteredType) => setActiveType(enteredType);

  React.useEffect(() => {
    if (formType) setActiveType(formType);
  }, [formType]);

  return (
    <div>
      <FormTitle center>{`Manually add ${activeType} to Your Itinerary`}</FormTitle>
      {!currentItem?.id && <Actions activeType={activeType} handleSetType={handleSetType} types={types} />}

      <div className={s.form}>
        {isFlightForm && <ManuallyFlight {...props} />}
        {isTransferForm && <ManuallyTransfer {...props} />}
      </div>

      {isFlightForm && !currentItem?.id && <Footer isManually {...props} />}
    </div>
  );
}
